module.exports = __webpack_public_path__ + "assets/7d05cf8913a2df2867de79d3bd5de183.png";